<div class="row wp-image-text">
    @if (isBrandLogoImageShown) {
    <div class="wp-image-text-image" style="text-align: center;">
        <!-- <img class="rounded mx-auto d-block" [src]="brandLogoImage" > -->
        <img class="img-fluid mx-auto d-block" [src]="brandLogoImage" >
    </div>
    }
    <div class="wp-image-text-text">
        <h4 class="text-center">{{brandName}}</h4>
    </div>
</div>

@if (isHeaderTextShown) {
    <div class="row alert alert-info">
      <h5 class="text-center">{{headerText}}</h5>
    </div>
}

<h2>{{'title' | txtResPipe: textResources }}</h2>
<h2>{{'subtitle' | txtResPipe: textResources }}</h2>

<button id="btn1" (click)="switchLanguage('lang')">Switch Language</button>

<!-- Select language -->
<div class="select-language-container">

    <!-- <select #langSelect (change)="translateService.use(langSelect.value)">
    <option *ngFor="let lang of translateService.getLangs()" [value]="lang" [selected]="lang === translateService.currentLang">{{ lang }}</option>
    </select> -->
<!-- 
    <select #langSelect (change)="textResourceService.useLang(langSelect.value)">
    <option *ngFor="let lang of textResourceService.getLangs()" [value]="lang" [selected]="lang === textResourceService.getCurrentLang()">{{ lang }}</option>
    </select> -->

</div>




